<template>
  <li @click="handleEmitSelect(dataSource)">
    <div class="free-video-icon"
        :class="{ 'active': active }"></div>
    <div class="free-video-name"
        :class="{ 'active': active }"
        v-html="replaceHighlight(dataSource.title)"></div>
    <div class="free-video-time">{{ dataSource.videoDuration | formatSeconds }}</div>
  </li>
</template>

<script>
import formatSeconds from '../filters/format-seconds'

export default {
  name: 'FreeVideoItem',
  props: {
    /**
       * 渲染数据
       */
    dataSource: {
      type: Object,
      required: true
    },
    /**
       * 控制不同的样式
       */
    active: {
      type: Boolean
    },
    /**
       * 高亮显示
       */
    hightlightWord: {
      type: String,
      default: ''
    }
  },
  filters: {
    formatSeconds
  },
  methods: {
    replaceHighlight (title) {
      const reg = new RegExp(this.hightlightWord, 'i')
      return title.replace(reg, '<span style="color: #f48f00;">' + this.hightlightWord + '</span>')
    },
    handleEmitSelect (dataSource) {
      this.$emit('select', dataSource)
    }
  }
}
</script>

<style lang="scss" scoped>
  @charset 'utf-8';
  @import '../style/main';

  $global-width: 750;

  .free-video {
    &-list {
      & > li {
        position: relative;
        margin-left: rem(98);
        padding: rem(30) 0;
        line-height: 1.5;

        &::after {
          content: "";
          transform: scaleY(0.5);
          position: absolute;
          right: 0;
          bottom: 0;
          left: 0;
          height: 1px;
          background-color: #e4e4e4;
        }
      }
    }

    &-icon {
      $size: rem(37);

      position: absolute;
      top: rem(30);
      left: rem(-30) - $size;
      width: $size;
      height: $size;
      background-image: url("../assets/images/freevideo-icon-gray-play.png");
      background-size: 100% 100%;

      &.active {
        background-image: url("../assets/images/freevideo-icon-orange-play.png");
        background-size: contain;
      }
    }

    &-name {
      max-width: rem(530);
      font-size: rem(28);
      color: #333;

      &.active {
        color: #f48f00;
      }
    }

    &-time {
      position: absolute;
      top: rem(30);
      right: rem(30);
      font-size: rem(24);
      color: #999;
    }
  }

  $global-width: 720;
</style>
